module.exports = __webpack_public_path__ + "static/media/moin_shaikh.7974b7b0.png";